import { mapMutations, mapState } from "vuex";

export const formBase = {
  computed: {
    ...mapState([
      'dataGrid_options',
    ]),
    ...mapState('diagramBuilder', [
      'currentNode',
      'metaData',
      'lines'
    ]),
  },
  methods: {
    ...mapMutations('diagramBuilder', [
      'updateNode',
      'updateMetaData',
      'updateCounter',
      'setCurrentNode'
    ]),
  }
}

export const outcomeMixin = {
  data() {
    return {
      newOutcome: '',
    }
  },
  computed: {
    showOutcomes: function() {
      if (this.currentNode.hasOwnProperty('outcomes')) {
        return this.currentNode.outcomes.length > 0
      } else {
        return false
      }
    }
  },
  methods: {
    addOutcome() {
      let currentNode = Object.assign({}, this.currentNode)
      
      if (!currentNode.hasOwnProperty('outcomes')) {
        currentNode['outcomes'] = []
      }

      if (this.newOutcome) {
        currentNode.outcomes.push({text: this.newOutcome, id: 'outcome' + +new Date, idx: currentNode.outcomes.length + 1})
        this.newOutcome = ''
        this.updateNode(currentNode)
      }
      this.setCurrentNode(currentNode.id)
      this.updateCounter()
    },
    updateOutcome(val, id) {
      let currentNode = Object.assign({}, this.currentNode)
      let index = currentNode.outcomes.findIndex(outcome => outcome.id === id)
      currentNode.outcomes[index].text = val
      this.updateNode(currentNode)
      this.updateCounter()
    },
    deleteOutcome(id) {
      let that = this
      let currentNode = Object.assign({}, this.currentNode)
      let index = this.currentNode.outcomes.findIndex(outcome => outcome.id === id)
      
      // delete related connections for the given outcome
      that.lines.forEach(line => {
        if (line.source.includes(id) || id === line.target) {
          that.$emit('remove-leader-lines', line.id)
        }
      })

      currentNode.outcomes.splice(index, 1)
      this.updateNode(currentNode)
      this.updateCounter()
    },
  },
}